module.exports = __webpack_public_path__ + "0254dc85f08eb9321f9575052b2b7388.png";